import { APIResponse } from '../models/api-response.model';
import { APIServiceService } from './apiservice.service';
import { Horse } from '../models/horse.model';
import { Observable } from 'rxjs';

export class HorsesEndpoint {

  constructor(private apiService: APIServiceService) {}
  endpoint = 'horses/';

  async create(horse: Horse): Promise<{success: boolean, data: Horse}> {
    try {
      const token = await this.apiService.getCurrentUserToken();
      if (!token) {
        throw new Error('no_auth_token');
      }
      const response = await this.apiService.doPOST(this.endpoint, token, horse).toPromise();
      return response;
    } catch (error) {
      throw error;
    }
  }
  
  async patch(horseID: number, detailsToUpdate: any): Promise<APIResponse> {
    try {
      const token = await this.apiService.getCurrentUserToken();
      if (!token) {
        throw new Error('no_auth_token');
      }
      const response = await this.apiService.doPOST(this.endpoint + 'patch/' + horseID, token, detailsToUpdate).toPromise();
      return response;
    } catch (error) {
      throw error;
    }
  }
  
  async update(horse: Horse): Promise<APIResponse> {
    try {
      const token = await this.apiService.getCurrentUserToken();
      if (!token) {
        throw new Error('no_auth_token');
      }
      const response = await this.apiService.doPOST(this.endpoint + horse.id, token, horse).toPromise();
      return response;
    } catch (error) {
      throw error;
    }
  }
  
  async delete(horseId: number): Promise<APIResponse> {
    try {
      const token = await this.apiService.getCurrentUserToken();
      if (!token) {
        throw new Error('no_auth_token');
      }
      const response = await this.apiService.doDELETE(this.endpoint + horseId, token).toPromise();
      return response;
    } catch (error) {
      throw error;
    }
  }
  
  async list(page?: number, size?: number): Promise<APIResponse> {
    try {
      const token = await this.apiService.getCurrentUserToken();
      if (!token) {
        throw new Error('no_auth_token');
      }
      const response = await this.apiService.doGET(this.endpoint, token, { page, size }).toPromise();
      return response;
    } catch (error) {
      throw error;
    }
  }
  
  async getByID(id: number): Promise<APIResponse> {
    try {
      const token = await this.apiService.getCurrentUserToken();
      if (!token) {
        throw new Error('no_auth_token');
      }
      const response = await this.apiService.doGET(this.endpoint + id, token, null).toPromise();
      return response;
    } catch (error) {
      throw error;
    }
  }
  
}
